"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Sections = require("sections");
var Snippets = require("snippets");
var CollectionTemplate = /** @class */ (function (_super) {
    __extends(CollectionTemplate, _super);
    function CollectionTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBgImage = function (section) { return (section && section.header_background_img ? section.header_background_img : null); };
        _this.getInfo = function (section) {
            if (section && section.extrainfoheader && section.extrainfo) {
                return { header: section.extrainfoheader, content: section.extrainfo };
            }
            return {};
        };
        _this.getSeo = function (meta, section) {
            if (meta && meta.seoContent) {
                return { header: meta.seoContent.title, content: meta.seoContent.content };
            }
            if (section && section.seo_header && section.seo_text) {
                return { header: section.seo_header, content: section.seo_text };
            }
            return {};
        };
        _this.getMeta = function (collection) { return (collection && collection.metafields ? collection.metafields : null); };
        _this.getSection = function (section) { return (section.collection && section.collection.settings ? section.collection.settings : null); };
        return _this;
    }
    CollectionTemplate.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        var data = this.props.data;
        var collection = data.collection, settings = data.settings, customer = data.customer, section = data.section, shop = data.shop;
        var meta = this.getMeta(collection);
        var collectionSection = this.getSection(section);
        var info = this.getInfo(collectionSection);
        var seo = this.getSeo(meta, collectionSection);
        var backgroundImage = this.getBgImage(collectionSection);
        var bgImage = ((_a = collection.metafields.custom) === null || _a === void 0 ? void 0 : _a.header_background_img) ? (_b = collection.metafields.custom) === null || _b === void 0 ? void 0 : _b.header_background_img : backgroundImage;
        var searchConfig = shop && shop.metafields && shop.metafields["reactify-search"] && shop.metafields["reactify-search"].config
            ? shop.metafields["reactify-search"].config
            : null;
        var infoHeader = ((_c = collection.metafields.custom) === null || _c === void 0 ? void 0 : _c.extrainfoheader) ? (_d = collection.metafields.custom) === null || _d === void 0 ? void 0 : _d.extrainfoheader : info
            ? info.header : null;
        var infoContent = ((_e = collection.metafields.custom) === null || _e === void 0 ? void 0 : _e.extrainfo) ? (_f = collection.metafields.custom) === null || _f === void 0 ? void 0 : _f.extrainfo : info
            ? info.content : null;
        return collection ? (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(Snippets.SearchPage, { searchKey: settings.reactify_search_app_key, searchUrl: settings.reactify_search_url, perPage: settings.reactify_search_per_page, searchTerm: null, collection: collection, bgImage: bgImage, customer: customer, seoHeader: seo ? seo.header : null, seoContent: seo ? seo.content : null, infoHeader: infoHeader, infoContent: infoContent, searchConfig: searchConfig }),
            section.ctahero ? (React.createElement("div", { className: "hidden pt-4 md:block bg-very-light-pink" },
                React.createElement(Snippets.Container, { width: "xl", className: "md:px-11 pb-4-8" },
                    React.createElement(Sections.CallToActionHero, __assign({}, this.props, { section: section.ctahero }))))) : null,
            section.cta ? React.createElement(Sections.CTA, __assign({}, this.props, { section: section.cta })) : "")) : null;
    };
    return CollectionTemplate;
}(React.Component));
exports.CollectionTemplate = CollectionTemplate;
